module.exports = __webpack_public_path__ + "img/norway-endocrine-nutritional-metabolic-diseases-male.d5884e98.png";